module.exports = __webpack_public_path__ + "static/media/package.3b678f7c.svg";